import client from './main-client';

export const lenderCategoryApi = (params) => client().get('/lender-company-categories', { params });
